// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121406/js/" + chunkId + "." + {"44":"94138af6","225":"ce5b99a5","481":"94cbdbcf","486":"5ccf40e8","770":"50baa8c2"}[chunkId] + ".0.6096510967567347.chunk.js";
};